import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import HtmlContent from '@/components/HtmlContent'
import Title from '@/components/Title'
import React from 'react'
import style from './styles/host.module.scss'

interface IProps {
  title: string
  backLink: string
  backLinkTitle?: string
  image: string
  content: string
}

const EducationHead = ({
  title,
  backLink,
  backLinkTitle = 'Образование',
  image,
  content
}: IProps): React.ReactElement => {
  return (
    <Container
      style={{ backgroundImage: `url(${String(image)})` }}
      className={style.host_bg}
    >
      <BackLink href={backLink} title={backLinkTitle} />
      <Title type='h1' className={style.host__title}>
        {title}
      </Title>

      <HtmlContent content={content} className={style.host__text} />
    </Container>
  )
}

export default EducationHead
